import { render, staticRenderFns } from "./MemberAdvisoryPage.vue?vue&type=template&id=31ebc522&"
import script from "./MemberAdvisoryPage.vue?vue&type=script&lang=js&"
export * from "./MemberAdvisoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports